export enum ButtonTypes {
	Default = 1,
	Down = 2,
	Icon = 3,
	ButtonIcon = 4,
	Email = 5,
}
